(function() {
    'use strict';
    angular.module('wbDashboard').factory('Login',
        ['$rootScope', '$location', 'Request', 'Auth', 'Session', 'Constant', 'Idle', 'Title', '$uibModal', '$interval',
    function ($rootScope, $location, Request, Auth, Session, Constant, Idle, Title, $uibModal, $interval) {
        var login = {};

        login.set = function (username, password, extra) {
            extra || (extra = {}); // jshint ignore:line

            return Request.make("auth", {
                username: username,
                password: password,
                extra: extra
            }).then(function(response) {
                Auth.setToken(response.data.token);
                Auth.setUsername(username);
                // emitting here will result in a duplicate since refresh is always called
                // $rootScope.$emit("AuthLoggedIn");

                return response.data;
            });
        };

        login.updateToken = function() {
            var guid = $location.search()['referrer_token']; // jshint ignore:line
            if (guid) {
                Auth.setToken(guid);
                return login.refresh(true);
            }
            return login.refresh();
        };

        login.createAxosPropertyBag = function() {
            return Request.make("auth_axos_token").then(function (response) {
                return response.data.token;
            });
        };

        login.refresh = function (redirected = false) {

            return Request.make("auth_refresh").then(function (response) {
                Auth.setToken(response.data.token);

                if (redirected) {
                    Auth.setAxosRedirect(true);
                }

                //refresh is always called
                $rootScope.$emit("AuthLoggedIn");

                return response.data;
            }).catch(function (err) {
                throw err;
            }).finally(function() {
                $location.search('referrer_token', null);
            });
        };

        login.forgotUsername = function (email) {
            return Request.make("username_remind", {email: email});
        };

        login.forgotPassword = function (email) {
            return Request.make("password_remind", {email: email});
        };

        login.getOTP = function (type = "sms") {
            var data = {
                send_type: 0,
                // extra: []
            };
            switch (type) {
                case 'sms':
                    data.send_type = 1;
                    break;
                case 'email':
                    data.send_type = 2;
                    break;
            }

            return Request.make("otp_send", data).then(function(response) {
                return response.data;
            });
        };

        login.validateOTP = function (code) {
            var data = {
                code: code,
                // extra: []
            };
            return Request.make("otp_validate", data).then(function(response) {
                return response.data;
            });
        };

        /**
         * @param {Object} data
         * @param {string} data.token
         * @param {string} data.password
         * @param {string} data.code
         * @returns {*}
         */
        login.reset = function (data) {
            data.password_confirmation = data.password;
            return Request.make("password_reset", data);
        };
        
        login.timeout = function($scope) {

            Idle.watch();
            Session.set('idleModal', false);

            $scope.$on('IdleStart', function() {
                Session.set('idleModal', true);

                Title.original(angular.element('title')[0].innerText);
                //stop the idle checking timer so this isn't called after it's open
                Idle.unwatch();
                //get new auth token, don't want it to expire while this is open
                login.refresh();

                //create modal scope
                var modalScope = $scope.$new(true);
                var startTime = Session.get('idleModalStartTimeout');

                if (!startTime || (moment.duration(moment().diff(startTime)).asSeconds() > Constant.logoutModalDelayTimeout + 10) ) {
                    Session.set('idleModalStartTimeout', moment());
                    startTime = Session.get('idleModalStartTimeout');
                }

                modalScope.modalInstance = $uibModal.open({
                    templateUrl: 'app/themes/aurea/templates/modal.logout.tpl.html',
                    scope: modalScope,
                    size: 'md',
                    windowClass: 'confirm-modal logout-modal'
                });

                modalScope.modalInstance.result.then(function () {
                    $scope.$state.go('public.logout');
                }).catch(function () {
                    //dismissed/cancelled
                    //continue watching again if the modal is dismissed
                    Idle.watch();
                }).finally(function() {
                    $interval.cancel(modalScope.interval);
                    Session.set('idleModal', false);
                    Session.set('idleModalStartTimeout', false);
                    Title.restore();
                });

                modalScope.updateModal = function() {
                    //calculate and display the time
                    var difference, remaining;
                    difference = moment.duration(moment().diff(startTime));
                    remaining = Constant.logoutModalDelayTimeout - Math.floor(difference.asSeconds());
                    modalScope.timerDisplay = moment(remaining * 1000).format('m:ss');
                    Title.setAsIdle(remaining);

                    if (Session.get('idleModal') === false) {
                        //another tab must have triggered it, so modal can be closed
                        modalScope.modalInstance.dismiss();
                    } else if (remaining < 0 || !Auth.isLoggedIn()) {
                        modalScope.modalInstance.close();
                    }

                };
                modalScope.updateModal();
                modalScope.interval = $interval(function() {
                    modalScope.updateModal();
                }, 1000);

            });
        };

        return login;

    }]);
})();
